module.exports = __webpack_public_path__ + "img/alive-user.d2de1bce.svg";